import {html, css, LitElement} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {localize} from '@/shared/localize/tcg-localize-behavior';
import sharedStyles from '@/shared/styles/tcg-shared-styles.js';
import {store} from '@/store.js';
import {connect} from 'pwa-helpers/connect-mixin.js';
import '@/app/aca-old-browser.js';
import '@sdb-develop/learning-frontend';
import '@/auth/aca-signin-auto-redirect';

@customElement('aca-signin-page')
class AcaSigninPage extends connect(store)(LitElement) {
    static styles = [
        sharedStyles,
        css`
            :host {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;

                background-attachment: fixed;
                background-clip: border-box;
                background-color: rgba(0, 0, 0, 0);
                background-image: url('/images/login-background.svg');
                background-origin: padding-box;
                background-position-x: 100%;
                background-position-y: 100%;
                background-repeat: no-repeat;
                background-size: cover;
            }

            .signin-container {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .logo-container {
                width: 320px;
                max-width: 100%;
                margin: 0 auto;
            }

            .logo {
                display: block;
                margin: 0 auto;
                width: auto;
                height: auto;
                max-width: min(320px, 100%);
                max-height: 150px;
                object-fit: contain;
            }

            .text {
                margin: 0 20px;
            }

            .title {
                padding: 16px 0;
                font-size: 24px;
                font-weight: 400;
            }

            .card-actions {
                margin-top: 15px;
            }

            #welcomeText {
                white-space: pre-wrap;
            }

            @media (max-width: 600px) {
                .signin-container {
                    display: block;
                    text-align: center;
                }
            }

            sdb-content-card {
                border: none;
                box-sizing: border-box;
                position: relative;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                border-bottom-left-radius: 20px;
                max-width: 80%;
                background-color: rgb(255, 255, 255);
            }
        `,
    ];

    @state() accessor _styleVars;

    render() {
        return html`
            <aca-old-browser></aca-old-browser>

            ${this._skipPreLogonWelcomeWelcomeScreen
                ? html` <aca-signin-auto-redirect></aca-signin-auto-redirect> `
                : html`
                      <sdb-content-card>
                          <div class="signin-container">
                              <div class="logo-container">
                                  <img
                                      class="logo"
                                      src="${this._welcomeLogoUrl}"
                                  />
                              </div>

                              <div class="text">
                                  <div class="title">${this._welcomeTitle}</div>
                                  <div id="welcomeText">${this._welcomeText}</div>
                              </div>
                              <div class="card-actions">
                                  ${this._accountCreationEnabled
                                      ? html`
                                            <sdb-content-button
                                                id="btnRegister"
                                                @click=${(e) => this.__register(e)}
                                                .label=${localize('register')}
                                            ></sdb-content-button>
                                        `
                                      : html``}
                                  <sdb-content-button
                                      id="btnNext"
                                      @click=${(e) => this.__signIn(e)}
                                      .label=${localize('next')}
                                  ></sdb-content-button>
                              </div>
                          </div>
                      </sdb-content-card>
                  `}
        `;
    }

    static get properties() {
        return {
            _settings: {
                type: Object,
            },
            _paperButtonRaised: {
                type: Boolean,
                value: false,
            },
        };
    }

    static get observers() {
        return ['_resourcesChanged(resources.*)'];
    }

    stateChanged(state) {
        this._skipPreLogonWelcomeWelcomeScreen =
            state.minervaSettings.skipPreLogonWelcomeWelcomeScreen || false;
        this._welcomeLogoUrl =
            state.minervaSettings.preLogonWelcomeLogoUrl ||
            state.minervaSettings.customerLogoUrl ||
            '/images/sdb-zorgt-logo.svg';
        this._welcomeTitle = state.minervaSettings.preLogonWelcomeTitle || 'SDB Leerplatform';
        this._welcomeText = state.minervaSettings.preLogonWelcomeText || localize('signInToUse');
        this._accountCreationEnabled = state.minervaSettings.accountCreationEnabled;
        this._accountCreationUrl = state.minervaSettings.accountCreationUrl;
        this._settings = state.minervaSettings;
    }

    connectedCallback() {
        super.connectedCallback();

        this.useKeyIfMissing = true;
    }

    _resourcesChanged() {
        if (!this._welcomeText) {
            this._welcomeText = localize('signInToUse');
        }
    }

    __signIn() {
        store.dispatch({type: 'SIGNIN'});
    }

    __register() {
        window.open(this._accountCreationUrl, '_blank');
    }
}
